import React, { memo, useCallback } from 'react';
import { IconButton } from '@material-ui/core';
import { Sync as SyncIcon } from '@material-ui/icons';
import { get as TableGetter } from '../table';

export const NotAllowedKeysForSearch = new Set(['?', '\\', '[', ']', '+', '(', ')', '*']);

const ErrorMessage = 'There are no orders in your queue. Please check back later!';

const MockFn = () => {};

const Visits = ({
  heading = '',
  classes,
  rows = [],
  columns = [],
  filterBy = '',
  loading = true,
  version = 1,
  hideSearch = false,
  hideRefresh = false,
  onFilter: handleFilter = () => {},
  onRowClick: handleRowClick = () => {},
  onKeyDown: handleKeyDown = () => {},
  onKeyUp: handleKeyUp = () => {},
  onRefresh: _handleRefresh = () => {},
}) => {
  const Table = TableGetter(version);

  const handleRefresh = useCallback(() => {
    if (loading) {
      return MockFn;
    }
    _handleRefresh();
    return MockFn;
  }, [loading, _handleRefresh]);

  return (
    <div className={classes.ordersV1}>
      <div className='page-header'>
        <div className='flex align-items-center gap-8'>
          <p className='page-heading'>{heading}</p>
          {
            !hideRefresh && (
              <IconButton
                size='small'
                className='primary-button'
                onClick={handleRefresh}
              >
                <SyncIcon fontSize='small' className={loading && 'animate-spin'} />
              </IconButton>
            )
          }
        </div>
        {
          !hideSearch && (
            <div className='page-keyword-search'>
              <span className='page-keyword-search-label'>Search</span>
              <input className='page-keyword-search-input' autoFocus type='text' value={filterBy} onKeyDown={handleKeyDown} onKeyUp={handleKeyUp} onChange={handleFilter}/>
            </div>
          )
        }
      </div>
      <div className='page-content'>
        <Table columns={columns} rows={rows} filterBy={filterBy} stickyHeader handler={{ onRowClick: handleRowClick }} />
        {
          (!loading && !rows.length) && (
            <div className='page-content-empty'>{ErrorMessage}</div>
          )
        }
      </div>
    </div>
  );
}

export default memo(Visits);
